import { XIcon } from "@heroicons/react/outline";

import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { addSchoolAdmin } from "../../../api/miniCrm.service";
import { EyeIcon, EyeOffIcon } from "../../../assets/icons";
import constant from "../../../utils/constant";
import User from "./user";
import userError from "./userError";

export default function SchoolAdminModal(props: any) {
  const alphaNumericExpression = new RegExp(/^[a-zA-Z0-9_@.-]*$/);
  const numericExpression = new RegExp(/^[0-9\b]+$/);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const [userErrors, setUserErrors] = useState({
    firstName: new userError(false, constant.UserErrorMessage.FirstName),
    lastName: new userError(false, constant.UserErrorMessage.LastName),
    username: new userError(false, constant.UserErrorMessage.UserName),
    password: new userError(false, constant.UserErrorMessage.Password),
    email: new userError(false, constant.UserErrorMessage.Email),
    emailFormat: new userError(false, constant.UserErrorMessage.EmailFormat),
    usernameLength: new userError(
      false,
      constant.UserErrorMessage.UsernameLength
    ),
    passwordLength: new userError(
      false,
      constant.UserErrorMessage.PasswordLength
    ),
  });
  const [user, setUser] = useState<User>({
    firstName: props.selectedUser?.firstName,
    createdByUserId: 1,
    email: props.selectedUser?.email,
    lastName: props.selectedUser?.lastName,
    passwordHash: props.selectedUser?.passwordHash,
    userId: props.selectedUser?.userId,
    username: props.selectedUser?.username,
    isTrial: props.selectedUser?.isTrail,
    roleId: parseInt(props.selectedUser?.roleId),
    stateId: props.selectedUser?.stateId ? props.selectedUser?.stateId : 1,
    districtId: props.selectedUser?.districtId
      ? props.selectedUser?.stateId
      : 1,
    schoolId: props.school.schoolId,
    schoolAccountId: props.school.schoolAccountId,
    updatedByUserId: 0,
    isActive: props.selectedUser?.isActive
      ? props.selectedUser?.isActive
      : false,
    isDisabled: props.selectedUser?.isDisabled,
  });
  const handleOnClose = () => {
    props?.handleSchoolAdminModal();
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const addUser = user;

    setUser(addUser);
    if (Validation(addUser)) {
      return;
    }
    addUser.roleId = constant.UserRoleId.SchoolAdmin;
    addUser.schoolAccountId = props?.school.schoolAccountId;
    addUser.schoolId = props?.school.schoolId;
    addUser.stateId = props?.school.stateId;
    addUser.districtId = props?.school.districtId;

    const updateResponse = addSchoolAdmin(addUser);
    updateResponse?.then((d) => {
      if (d.data.isSuccess === true) {
        toast.success("User added successfully.");
        props?.handleSchoolAdminModal(props?.school);
      } else {
        toast.warning("Something went wrong");
      }
    });
  };

  function isValidateEmail(email): boolean {
    const reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
    if (reg.test(email)) {
      return true;
    }
    return false;
  }

  const Validation = (user: any) => {
    const error = userErrors;
    error.firstName.isError = !user.firstName ? true : false;
    error.lastName.isError = !user.lastName ? true : false;
    error.username.isError = !user.username ? true : false;
    error.usernameLength.isError = !user.username
      ? false
      : user.username.length < 6 || user.username.length > 60;
    if (user.isSSOEnabled === false) {
      error.password.isError = !user.passwordHash ? true : false;
      error.passwordLength.isError = !user.passwordHash
        ? false
        : user.passwordHash.length < 6 || user.passwordHash.length > 60;
    }

    error.email.isError = !user.email ? true : false;
    error.emailFormat.isError = !user.email
      ? false
      : !isValidateEmail(user.email);

    setUserErrors({ ...error });
    return (
      error.firstName.isError ||
      error.lastName.isError ||
      error.username.isError ||
      error.password.isError ||
      error.email.isError ||
      error.emailFormat.isError ||
      error.usernameLength.isError ||
      error.passwordLength.isError
    );
  };

  return (
    <Fragment>
      <div className="fixed inset-0 z-40 flex items-center bg-black bg-opacity-50 sm:items-center sm:justify-center">
        <div
          className="w-full flex flex-col justify-between overflow-hidden h-auto max-h-80percent bg-white rounded-t-lg dark:bg-gray-800 sm:rounded-lg sm:m-4 sm:max-w-5xl"
          role="dialog"
        >
          <header>
            {/* Header */}
            <div className="px-4 py-4 bg-gray-50">
              <div className="flex items-start justify-between space-x-3">
                <div className="space-y-1">
                  <div className="text-lg font-medium text-gray-900">
                    <h2 className="text-xl mb-2">Add/Edit School Admin </h2>
                  </div>
                </div>
                <div className="h-7 flex items-center">
                  <button
                    type="button"
                    className="text-gray-400 hover:text-gray-500"
                    onClick={() => props.handleSchoolAdminModal()}
                  >
                    <span className="sr-only">Close panel</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </header>
          <div className="w-full relative overflow-auto px-4 py-6">
            <div>
              <div className="grid grid-cols-1 gap-y-6 gap-x-6 sm:grid-cols-2 xl:grid-cols-2 sm:gap-x-8">
                <div>
                  <label
                    htmlFor="user_name"
                    className="block text-sm text-gray-500"
                  >
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type="text"
                      name="user_firstName"
                      id="user_firstName"
                      value={user.firstName}
                      maxLength={60}
                      onChange={(e) => {
                        if (
                          alphaNumericExpression.test(e.target.value.toString())
                        ) {
                          setUser({ ...user, firstName: e.target.value });
                        }
                      }}
                      className="border py-2 px-4 block w-full shadow-sm text-gray-900 focus:ring-primary-violet focus:border-primary-violet border border-gray-300 rounded-md"
                    />
                    {userErrors.firstName.isError && (
                      <span className="text-red-500">
                        {userErrors.firstName.message}
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="student_id"
                    className="block text-sm  text-gray-500"
                  >
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type="text"
                      name="user_lastName"
                      id="user_lastName"
                      value={user.lastName}
                      maxLength={60}
                      onChange={(e) => {
                        if (
                          alphaNumericExpression.test(e.target.value.toString())
                        ) {
                          setUser({ ...user, lastName: e.target.value });
                        }
                      }}
                      className="border py-2 px-4 block w-full shadow-sm text-gray-900 focus:ring-primary-violet focus:border-primary-violet border border-gray-300 rounded-md"
                    />
                    {userErrors.lastName.isError && (
                      <span className="text-red-500">
                        {userErrors.lastName.message}
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="user_username"
                    className="block text-sm  text-gray-500"
                  >
                    Username <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type="text"
                      name="user_username"
                      id="user_username"
                      value={user.username}
                      autoComplete="off"
                      maxLength={60}
                      minLength={6}
                      onChange={(e) => {
                        if (
                          alphaNumericExpression.test(e.target.value.toString())
                        ) {
                          setUser({ ...user, username: e.target.value });
                        }
                      }}
                      className="border py-2 px-4 block w-full shadow-sm text-gray-900 focus:ring-primary-violet focus:border-primary-violet border border-gray-300 rounded-md"
                    />
                    {userErrors.username.isError && (
                      <span className="text-red-500">
                        {userErrors.username.message}
                      </span>
                    )}
                    {userErrors.usernameLength.isError && (
                      <span className="text-red-500">
                        {userErrors.usernameLength.message}
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="user_password"
                    className="block text-sm  text-gray-500"
                  >
                    Password <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <div className="flex">
                      <input
                        type={showPassword === true ? "text" : "password"}
                        name="user_password"
                        id="user_password"
                        autoComplete="new-password"
                        value={user.passwordHash}
                        maxLength={60}
                        minLength={6}
                        onChange={(e) => {
                          setUser({ ...user, passwordHash: e.target.value });
                        }}
                        className="border py-2 px-4 block w-full shadow-sm text-gray-900 focus:ring-primary-violet focus:border-primary-violet border border-gray-300 rounded-md"
                      />
                      {showPassword === true && (
                        <EyeIcon
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          title="Hide password"
                          className="ml-2 mt-1 w-5 text-gray-500 cursor-pointer"
                        />
                      )}
                      {showPassword === false && (
                        <EyeOffIcon
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          title="Show password"
                          className="ml-2 mt-1 w-5 text-gray-500 cursor-pointer"
                        />
                      )}
                    </div>
                    {userErrors.password.isError && (
                      <span className="text-red-500">
                        {userErrors.password.message}
                      </span>
                    )}
                    {userErrors.passwordLength.isError && (
                      <span className="text-red-500">
                        {userErrors.passwordLength.message}
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="user_email"
                    className="block text-sm  text-gray-500"
                  >
                    Email <span className="text-red-500">*</span>
                  </label>

                  <div className="mt-1">
                    <input
                      type="text"
                      name="user_email"
                      id="user_email"
                      value={user.email}
                      maxLength={60}
                      onChange={(e) => {
                        setUser({ ...user, email: e.target.value });
                      }}
                      className="border py-2 px-4 block w-full shadow-sm text-gray-900 focus:ring-primary-violet focus:border-primary-violet border border-gray-300 rounded-md"
                    />
                    {userErrors.email.isError && (
                      <span className="text-red-500">
                        {userErrors.email.message}
                      </span>
                    )}
                    {userErrors.emailFormat.isError && (
                      <span className="text-red-500">
                        {userErrors.emailFormat.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Action Buttons -->  */}
          <footer className="flex flex-col items-center justify-end px-6 py-4 sm:flex-row bg-gray-50 dark:bg-gray-800">
            <div className="flex-shrink-0">
              <div className="flex justify-end pt-4">
                <button
                  type="button"
                  onClick={(e) => handleSubmit(e)}
                  className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                >
                  Save
                </button>

                <button
                  type="button"
                  onClick={props?.handleSchoolAdminModal}
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </Fragment>
  );
}
